export default {
  setApiUrl(state, apiUrl) {
    state.apiUrl = apiUrl;
  },
  setGoogleClientId(state, googleClientId) {
    state.googleClientId = googleClientId;
  },
  setFacebookClientId(state, facebookClientId) {
    state.facebookClientId = facebookClientId;
  },
  setCaptchaKey(state, captchaKey) {
    state.captchaKey = captchaKey;
  },
};
